declare var require:any;
import  './product-technical-specs.template.html';
import {productTechnicalSpecsController} from './product-technical-specs.controller'

export var productTechnicalSpecsComponent = {
    template: require('./product-technical-specs.template.html'),
    controller:productTechnicalSpecsController

}


// WEBPACK FOOTER //
// ./src/components/product-technical-specs/product-technical-specs.ts